"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var system_1 = require("@mui/system");
var _1 = require(".");
var hooks_1 = require("../../hooks");
var styles_1 = require("../../styles");
var Icon_1 = __importDefault(require("./Icon"));
var IconButton_1 = __importDefault(require("./IconButton"));
var TokenLogo_1 = __importDefault(require("./TokenLogo"));
var TokenName_1 = __importDefault(require("./TokenName"));
var HiSwitchHorizontal_1 = require("@react-icons/all-files/hi/HiSwitchHorizontal");
function TokenPriceCompare(_a) {
    var leftToken = _a.leftToken, rightToken = _a.rightToken, price = _a.price, className = _a.className, toggleInverted = _a.toggleInverted, loading = _a.loading;
    var _toggleInverted = function (e) {
        e.stopPropagation();
        toggleInverted();
    };
    if (loading) {
        return ((0, jsx_runtime_1.jsx)(StyledContainer, { children: (0, jsx_runtime_1.jsx)(_1.Loader, { width: 120, height: 30 }) }));
    }
    if (!leftToken || !rightToken) {
        return ((0, jsx_runtime_1.jsx)(StyledContainer, { children: (0, jsx_runtime_1.jsx)(styles_1.StyledText, { children: "-" }) }));
    }
    return ((0, jsx_runtime_1.jsxs)(StyledContainer, __assign({ className: "twap-price-compare ".concat(className) }, { children: [(0, jsx_runtime_1.jsx)(LeftToken, { token: leftToken }), (0, jsx_runtime_1.jsx)(IconButton_1.default, __assign({ onClick: _toggleInverted }, { children: (0, jsx_runtime_1.jsx)(Icon_1.default, { icon: (0, jsx_runtime_1.jsx)(HiSwitchHorizontal_1.HiSwitchHorizontal, {}) }) })), (0, jsx_runtime_1.jsx)(RightToken, { price: price, token: rightToken })] })));
}
var LeftToken = function (_a) {
    var token = _a.token;
    return ((0, jsx_runtime_1.jsxs)(styles_1.StyledRowFlex, __assign({ style: { width: "auto", gap: 5 }, className: "left-token" }, { children: [(0, jsx_runtime_1.jsx)(TokenLogo_1.default, { logo: token === null || token === void 0 ? void 0 : token.logoUrl }), (0, jsx_runtime_1.jsx)(styles_1.StyledText, __assign({ className: "value" }, { children: "1" })), (0, jsx_runtime_1.jsx)(TokenName_1.default, { name: token === null || token === void 0 ? void 0 : token.symbol })] })));
};
var RightToken = function (_a) {
    var token = _a.token, price = _a.price;
    var formattedValue = (0, hooks_1.useFormatNumber)({ value: price });
    var formattedValueTooltip = (0, hooks_1.useFormatNumber)({ value: price, decimalScale: 18 });
    return ((0, jsx_runtime_1.jsxs)(styles_1.StyledRowFlex, __assign({ style: { width: "auto", gap: 5 }, className: "right-token" }, { children: [(0, jsx_runtime_1.jsx)(TokenLogo_1.default, { logo: token === null || token === void 0 ? void 0 : token.logoUrl }), (0, jsx_runtime_1.jsxs)(_1.Tooltip, __assign({ text: "".concat(formattedValueTooltip, " ").concat(token === null || token === void 0 ? void 0 : token.symbol) }, { children: [(0, jsx_runtime_1.jsxs)("span", __assign({ className: "value" }, { children: [" ", "".concat(formattedValue, " ")] })), (0, jsx_runtime_1.jsxs)("span", __assign({ className: "symbol" }, { children: [" ", token === null || token === void 0 ? void 0 : token.symbol] }))] }))] })));
};
exports.default = TokenPriceCompare;
TokenPriceCompare.LeftToken = LeftToken;
TokenPriceCompare.RightToken = RightToken;
var StyledContainer = (0, system_1.styled)(system_1.Box)({
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "flex",
    justifyContent: "space-between",
    gap: 3,
    alignItems: "center",
    "& * ": {
        fontSize: 14,
    },
    svg: {
        fontSize: "20px",
    },
    "& .twap-token-logo": {
        width: 22,
        height: 22,
        minWidth: 22,
        minHeight: 22,
    },
});
